import { render } from "./CreateBeneficiary.vue?vue&type=template&id=6b887c89"
import script from "./CreateBeneficiary.vue?vue&type=script&lang=js"
export * from "./CreateBeneficiary.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__